// store/Auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  verifyUser,
  loginUser,
  logoutUser,
  forgotPassword,
  resetPassword,
  markTrainingVideoComplete,
} from "./authThunks";
import { UpdateDisabledOutlined } from "@mui/icons-material";

const initialState = {
  loginMethod: null,
  permissions: [],
  loading: false,
  error: null,
  user: null,
  forgotPasswordMessage: null,
  resetPasswordMessage: null,
  initialized: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // verifyUser (MSAL)
      .addCase(verifyUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.initialized = false;
      })
      .addCase(verifyUser.fulfilled, (state, action) => {
        state.error = null;
        state.user = action.payload.data.user;
        state.loginMethod = action.payload.loginMethod;
        state.loading = false;
        state.initialized = true;
      })
      .addCase(verifyUser.rejected, (state, action) => {
        console.error(
          "❌ verifyUser failed",
          action.payload || action.error.message
        );
        state.loading = false;
        state.user = null;
        state.loginMethod = null;
        state.initialized = true; // ✅ VERY important to allow UI to show
      })
      // loginUser (Basic Auth)
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.user = action.payload.data.user;
        state.loginMethod = action.payload.loginMethod; // "basic"
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // logoutUser
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.permissions = [];
        state.loginMethod = null;
        state.error = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // forgotPassword
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.forgotPasswordMessage = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.forgotPasswordMessage = action.payload.message;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // resetPassword
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.resetPasswordMessage = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.resetPasswordMessage = action.payload.message;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(markTrainingVideoComplete.fulfilled, (state, action) => {
        state.user = action.payload;
      });
  },
});

export const selectPermissions = (state) => state.auth.permissions;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthInitialized = (state) => state.auth.initialized;

export default authSlice.reducer;
